window._ = require('lodash');

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

    window.jQuery.selectize = require('selectize').default;
    // window.ApexCharts = require('apexcharts').default;
    window.peity = require('peity');

    window.IMask = require('imask').default;

    window.autosize = require('autosize');

    // require('tabler/js/tabler');

    window.moment = require('moment');

    require('jquery-ui/ui/widgets/datepicker.js');

    window.feather = require('feather-icons');

    const flatpickr = require("flatpickr");

    window.jQuery.colorpicker = require("bootstrap-colorpicker").default;

    window.parsley = require('parsleyjs');
    require('parsleyjs/dist/i18n/ko');

    window.$.extend(window.parsley.options, {
        classHandler: function (field) {
            return field.$element.parents('.was-error');
        },
        errorsContainer: function (field) {
            return field.$element.parents('.was-error');
        },
        errorClass: 'is-invalid',
        successClass: 'is-valid',
        errorsWrapper: '<div class="text-red was-feedback"></div>',
        errorTemplate: '<div></div>',
        // Excluded inputs by default
        excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled]',
    });

    window.Tablesort = require('tablesort');
    require('tablesort/src/sorts/tablesort.date.js');
    require('tablesort/src/sorts/tablesort.dotsep.js');
    require('tablesort/src/sorts/tablesort.number.js');

    window.Prism = require('prismjs');

    // init
    // $('[data-toggle="tooltip"]').tooltip()
    // $('[data-toggle="popover"]').popover()

    // jquery ui effect off
    window.$.fx.off = true;

    // Load Highcharts
    window.Highcharts = require('highcharts');
    // // Alternatively, this is how to load Highstock. Highmaps is similar.
    // // var Highcharts = require('highcharts/highstock');

    // // Load the exporting module, and initialize it.
    // require('highcharts/modules/exporting')(Highcharts);
    require('highcharts/modules/sankey')(Highcharts);

    // // Generate the chart

    Highcharts.theme = {
        "colors": ["#4f98d2", "#de9729", "#5c66de", "#5bc154", "#9f4cc7", "#9bb837", "#e368d8",
                "#52943e", "#c5379e", "#63c595", "#e33d88", "#3a8b66", "#df3c67", "#3cbdcd",
                "#cc3f26", "#5d7cdd", "#c2ab3a", "#7855b3", "#c85f19", "#cc80e0", "#486a2a",
                "#e76eab", "#787e2e", "#a24e99", "#afb16c", "#b03273", "#d59848", "#6463a4",
                "#e6804e", "#a798df", "#916d2c", "#db8ebb", "#a25030", "#96547c", "#ed5753",
                "#d8996c", "#ab4361", "#e48080", "#bc3441", "#a65655"],
        "chart": {
            "style": {
                "fontFamily": "inherit"
            },
        },
        "title": {
            "text": "",
            "align": "left",
            "style": {
                "fontFamily": "inherit",
                "fontWeight": "bold"
            }
        },
        "subtitle": {
            "align": "left",
            "style": {
                "fontFamily": "inherit"
            }
        },
        "legend": {
            "align": "center",
            "verticalAlign": "bottom",
            "borderWidth": 0
        },
        "xAxis": {
            "gridLineWidth": 1,
            "gridLineColor": "#F3F3F3",
            "lineColor": "#F3F3F3",
            "minorGridLineColor": "#F3F3F3",
            "tickColor": "#F3F3F3",
            "tickWidth": 1
        },
        "yAxis": {
            "min": 0,
            "gridLineColor": "#F3F3F3",
            "lineColor": "#F3F3F3",
            "minorGridLineColor": "#F3F3F3",
            "tickColor": "#F3F3F3",
            "tickWidth": 1
        },
        "plotOptions": {
            "line": {
                "marker": {
                    "enabled": false
                }
            },
            "spline": {
                "marker": {
                    "enabled": false
                }
            },
            "area": {
                "marker": {
                    "enabled": false
                }
            },
            "areaspline": {
                "marker": {
                    "enabled": false
                }
            },
            "pie": {
                "allowPointSelect": true,
                "cursor": 'pointer',
                "dataLabels": {
                    "enabled": true,
                    "format": '<b>{point.name}</b>: {point.percentage:.1f} %',
                    "style": {
                        "color": (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                    }
                },
                "showInLegend": true,
                "tooltip": {
                    "headerFormat": '<span style="font-size: 10px">{series.name}</span><br/>',
                    "pointFormat": '{point.name}: <b>{point.y}</b>'
                },
            },
            "sankey": {
                "dataLabels": {
                    // "backgroundColor": "#FFFFFF",
                    // "boderWidth": 0,
                    "style": {
                        // "fontWeight": "bold",
                        // "textOutline": "1px contrast",
                        "textOutline": "1px contrast",
                        // "color": "#000000",
                        // "fontWeight": "inherit",
                        // "textOutline": "0px"
                    },
                },
            },
        },
        "credits": {
            "enabled": false
        },
    };

    // Apply the theme
    window.Highcharts.setOptions(Highcharts.theme);


} catch (e) {
    console.error('bootstrap', e);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });


window.selectAll = (o, target) => {
    var checkboxes = document.getElementsByName(target);
    for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = o.checked;

    }
}

window.toggleStatus = () => {
}



window.toggleSidebar = () => {
    var element = document.getElementById('sidebar');
    if (element.style.display === 'none') {
        element.style.display = '';
        document.body.classList.remove('sidebar-hide')
    } else {
        element.style.display = 'none';
        document.body.classList.add('sidebar-hide')
    }
}
